<div class="p-8">
  <app-loader *ngIf="isLoading"></app-loader>
  <div class="" [ngClass]="userPermissions && (userPermissions.includes('view_app') && userPermissions.includes('view_apptemplate')) ? 'menus' : 'bg-flag'" *ngIf="!isFromGCC">
    <div [class.active]="templateFlag" style="border-radius:5px 0 0 5px;" (click)="template(false)" *ngIf="userPermissions && userPermissions.includes('view_apptemplate')">Templates
    </div>
    <div *ngIf="isAdmin && userPermissions && (userPermissions.includes('view_app'))" [class.active]="userAppFlag" style="border-radius: 0 5px 5px 0;" (click)="userApplication(false)">
      User Solutions
    </div>
    <div *ngIf="!isAdmin &&  userPermissions && userPermissions.includes('view_app')"  [class.active]="userAppFlag" style="border-radius: 0 5px 5px 0;" (click)="userApplication(false)">
      My Solutions
    </div>
  </div>
 <div class="my-6 text-right">
  <div class="menus1" *ngIf="isFromGCC">
    <div *ngIf="isAdmin" [class.active]="userAppFlag" style="border-radius: 0 5px 5px 0;" (click)="userApplication(false)">
      Participant Solutions
    </div>
  </div>
  <div class="flex mr-2 justify-end">
    <div class="relative w-full btn-1 my-6">
      <label class="flex absolute inset-y-0  items-center pl-3 pointer-events-none">
        <svg aria-hidden="true" class="w-5 text-gray-500 dark:text-gray-400" fill="currentColor" viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z"
            stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </label>
      <input type="text" id="simple-search" class="br-1 btn-1 border-gray-200 org-name block p-2.5"
        placeholder=" Search by Application Id/Name/Created by" style="padding-left: 35px;" (keyup)="applyFilter($event)"
        [formControl]="searchControl">
    </div>
    <div class="my-6 mr-1">
      <input type="month" class="br-1 btn-5 border-gray-200 org-name block p-2" title="Select Month & Year" [max]="maxDate" [formControl]="dateControl" (change)="handleDatePicker($event)" style="padding: 25px;">
    </div>
    <div class="push my-6 mr-2">
      <select name="labNames" id="" class="btn-2 border-gray-200 rounded-lg  input-style org-name"
        (change)="onChangeOrgType($event)" *ngIf="isAdmin && isTemplate" [formControl]="clearDropDown">
        <option value="" class="org-name">All Types</option>
        <ng-container>
          <option *ngFor="let option of dropdownOptions" [value]="option">{{option}}</option>
        </ng-container>
      </select>
      <select name="labNames" id="" class="btn-2 border-gray-200 rounded-lg  mx-2 input-style org-name"
        (change)="onChangeStatus($event)" *ngIf="isAdmin" [formControl]="clearDropDown">
        <option value="" class="org-name">All Status</option>
        <ng-container *ngIf="isTemplate; else userSolutionStatus">
          <option *ngFor="let option of dropdownStatus" [value]="option">{{ option }}</option>
        </ng-container>
        <ng-template #userSolutionStatus>
          <option *ngFor="let option of dropdownUserSolutionStatus" [value]="option">{{ option }}</option>
        </ng-template>
      </select>
      <!-- refer lablist page -->
 
      <!-- <select  name="labNames" id=""
              class="btn-2 border-gray-200 rounded-lg mb-5 input-style org-name">
            <option value="" disabled selected></option>
          </select> -->
    </div>
    <div class="my-6 text-right flex"  *ngIf="isFromGCC">
      <button class="bg-greenish-blue text-white p-2 rounded-lg shadow-xl hover:bg-red-600 flex justify-center" (click)="backtoGCC()">
        <svg stroke="currentColor" class="" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1.35em" width="1.35em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path></svg>Back to GIAC
      </button>
    </div>
    <div *ngIf="isAdmin && !isFromGCC" class="dropdown my-6 text-right relative">
      <button class="bg-greenish-blue text-white p-2 rounded-lg shadow-xl inline-flex items-center"
        (click)="toggleMenu()">Module Name
        <i class="p-4 m-2 arrow down text-white"></i>
      </button>
      <div *ngIf="isMenuOpen"
        class="origin-top-right moduleName absolute -right-5 mt-2 text-center rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
        <div class="py-1 cursor-pointer">
          <a class="drop-down-links" (click)="onSelectModule('')">All</a>
          <a class="drop-down-links" (click)="onSelectModule('iot')">IOT</a>
          <a class="drop-down-links" (click)="onSelectModule('robotics')">Robotics</a>
          <a class="drop-down-links" (click)="onSelectModule('data_science')">Data Science</a>
          <a class="drop-down-links" (click)="onSelectModule('aiot')">AIoT</a>
          <a class="drop-down-links" (click)="onSelectModule('artificial_intelligence')">Artificial Intelligence</a>
          <a class="drop-down-links" (click)="onSelectModule('iiot')">IIoT</a>
          <a class="drop-down-links" (click)="onSelectModule('aiot_v2')">AIoT V2</a>
        </div>
      </div>
    </div>
 
 
    <div class="my-6 text-right">
      <button *ngIf="(isAdmin && !userAppFlag && !isFromGCC  && userPermissions && (userPermissions.includes('create_apptemplate')) || (isAdmin && userAppFlag && userPermissions.includes('create_app')))" class="bg-greenish-blue text-white p-2 rounded-lg shadow-xl hover:bg-red-600"
        (click)="navigateToUrlFrom('create')">New Solution</button>
    </div>
  </div>
  <!-- <div class="flex mr-2 justify-end">
    <div class="my-6 text-right flex"  *ngIf="isAdmin && isFromGCC">
      <button class="bg-greenish-blue text-white p-2 rounded-lg shadow-xl hover:bg-red-600 flex justify-center" (click)="backtoGCC()">
        <svg stroke="currentColor" class="" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1.35em" width="1.35em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path></svg>Back to GIAC
      </button>
    </div>
    <div *ngIf="isAdmin && !isFromGCC" class="dropdown my-6 text-right relative">
      <button class="bg-greenish-blue text-white p-2 rounded-lg shadow-xl inline-flex items-center"
        (click)="toggleMenu()">Module Name
        <i class="p-4 m-2 arrow down text-white"></i>
      </button>
      <div *ngIf="isMenuOpen"
        class="origin-top-right absolute -right-5 mt-2 text-center rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
        <div class="py-1 cursor-pointer">
          <a class="drop-down-links" (click)="onSelectModule('all')">All</a>
          <a class="drop-down-links" (click)="onSelectModule('iot')">IOT</a>
          <a class="drop-down-links" (click)="onSelectModule('robotics')">Robotics</a>
          <a class="drop-down-links" (click)="onSelectModule('data_science')">Data Science</a>
          <a class="drop-down-links" (click)="onSelectModule('aiot')">AIoT</a>
          <a class="drop-down-links" (click)="onSelectModule('artificial_intelligence')">Artificial Intelligence</a>
          <a class="drop-down-links" (click)="onSelectModule('iiot')">IIoT</a>
        </div>
      </div>
    </div>
 
 
    <div class="my-6 text-right">
      <button *ngIf="isAdmin && !isFromGCC" class="bg-greenish-blue text-white p-2 rounded-lg shadow-xl hover:bg-red-600"
        (click)="navigateToUrlFrom('create')">New Solution</button>
    </div>
  </div> -->
  <div class="flex">
    <div class="overflow-x-auto w-full table-wrapper">
      <div class="min-w-screen flex justify-center font-sans">
        <div class="w-full">
          <div class="bg-white shadow-md rounded my-6">
            <table class="w-full table-auto">
              <thead class="bg-greenish-blue text-white">
                <tr class="text-white-600 uppercase text-sm leading-normal">
                  <th class="text-left sNo">#</th>
                  <th class="text-left">Name</th>
                  <th class="text-center" *ngIf="isTemplate">Application Type</th>
                  <th class="text-center">Module Name</th>
                  <th class="text-left">Description</th>
                  <th class="text-left">Created By</th>
                  <th class="text-center">Created At</th>
                  <th class="text-center" *ngIf="isAdmin && !isFromGCC">Status</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody class="text-gray-600 text-sm font-light"  id="tableBody">
                <tr class="border-b border-gray-200 hover:bg-gray-100"
                  *ngFor="let item of filteredApplications; let i = index">
                  <td class="text-left dark-text sNo">
                    <span class="dark-text">{{(currentPage - 1) * pageSize + i + 1}}</span>
                  </td>
                  <td class="text-left">
                    <!-- <div class="clickable-link" (click)="openApplication(item)">{{item.applicationName}}</div> -->
                    <div [class.non-clickable-link]= "(!isAdmin && templateFlag) && (userPermissions.includes('edit_apptemplate') || userPermissions.includes('edit_app'))"  [class.clickable-link]= "((isAdmin) || (!isAdmin && userAppFlag)) && (userPermissions.includes('edit_apptemplate') || userPermissions.includes('edit_app'))"(click)="((isAdmin) ||(!isAdmin && userAppFlag) === true) && (userPermissions.includes('edit_apptemplate') || userPermissions.includes('edit_app'))?openApplication(item):null">{{item.applicationName}}</div>
                    <div class="light-text">{{item.applicationIdentifier}}</div>
                  </td>
                  <td class="text-center dark-text" [style.text-transform]='"uppercase"' *ngIf="isTemplate">{{item.applicationType}}</td>
                  <td class="text-center dark-text" [style.text-transform]='"uppercase"'>{{item.moduleName}}</td>
                  <td class="text-left light-text">
                    {{(item.applicationDesc && item.applicationDesc.length > 40) ? (item.applicationDesc |
                    slice:0:40)+'..' : (item.applicationDesc)}}
                  </td>
                  <td class="text-left light-text">{{item.createdBy}}</td>
                  <td class="text-center light-text">
                    <span class="createdDate">{{ item.createdDate | date:'dd/MM/yyyy' }} </span>
                    <span>{{ item.createdDate | date:'hh:mm a' }}</span>
                  </td>
                  <td class="text-center" *ngIf="isAdmin && !isFromGCC">
                    <span *ngIf="item.isPublishedInternally && isTemplate " [ngClass]="{'disabled': !userPermissions.includes('publish_app_template')}" class="green-tag" (click)="(userPermissions.includes('publish_app_template'))?publishModal(item):null">
                      Published Internally
                    </span>
                    <span *ngIf="item.isPublishedExternally && isTemplate" [ngClass]="{'disabled': !userPermissions.includes('publish_app_template')}" class="green-tag" (click)="(userPermissions.includes('publish_app_template'))?publishModal(item):null">
                      Published Externally
                    </span>
                    <span *ngIf="!item.isPublishedExternally && !item.isPublishedInternally && isTemplate " [ngClass]="{'disabled': !userPermissions.includes('publish_app_template')}" class="red-tag" (click)="(userPermissions.includes('publish_app_template'))?publishModal(item):null">
                      Unpublished
                    </span>
                    <!-- this one is for user application -->
                    <span *ngIf="item.isPublishedExternally && !isTemplate" class="green-tag" [ngClass]="{'disabled': !userPermissions.includes('edit_app')}" (click)="(userPermissions.includes('publish_app') && userAppFlag)?publishModal(item):null">
                      Published
                    </span>
                    <!-- this is common for both -->
                    <span *ngIf="!item.isPublishedExternally && !isTemplate " class="red-tag" [ngClass]="{'disabled': !userPermissions.includes('edit_app')}" (click)="(userPermissions.includes('publish_app') && userAppFlag)?publishModal(item):null">
                      Unpublished
                    </span>
                  </td>
                  <td class="text-center">
                    <div class="flex item-center justify-center">
 
                      <div class="action-item" *ngIf="item.moduleName != 'data_science' && userAppFlag">
                        <a
                        (click)="navigateToReference(item.applicationIdentifier, 'application', 'circuit')">
                          <img src="../../../../assets/img/admin/view-circuit.svg" alt = "View Circuit"
                            title="View Circuit">
                        </a>
                      </div>
                      <div class="action-item" *ngIf="item.moduleName != 'data_science' && !userAppFlag">
                        <a
                        (click)="navigateToReference(item.applicationIdentifier, 'template', 'circuit')">
                          <img src="../../../../assets/img/admin/view-circuit.svg" alt = "View Circuit"
                            title="View Circuit">
                        </a>
                      </div>
                      <div class="action-item" *ngIf="userAppFlag">
                        <a
                        (click)="navigateToReference(item.applicationIdentifier, 'application', 'block')">
                          <img src="../../../../assets/img/admin/view-block.svg" alt = "View Block Programming"
                            title="View Block Programming">
                        </a>
                      </div>
                      <div class="action-item" *ngIf="!userAppFlag">
                        <a
                        (click)="navigateToReference(item.applicationIdentifier, 'template', 'block')">
                          <img src="../../../../assets/img/admin/view-block.svg" alt = "View Block Programming"
                            title="View Block Programming">
                        </a>
                      </div>
                      <div class="action-item" *ngIf="!userAppFlag">
                        <a (click)="navigateToReference(item.applicationIdentifier, 'template', 'reference-python')">
                          <img src="../../../../assets/img/admin/python_icon.svg" alt = "View Python Program"
                            title="View Python Program">
                        </a>  
                      </div>
                      <div class="action-item" *ngIf="userAppFlag">
                        <a (click)="navigateToReference(item.applicationIdentifier, 'application', 'reference-python')">
                          <img src="../../../../assets/img/admin/python_icon.svg" alt = "View Python Program"
                            title="View Python Program">
                        </a>
                      </div>
                      <div *ngIf="((!userAppFlag && isAdmin && userPermissions.includes('edit_apptemplate')) ||( userAppFlag && userPermissions.includes('edit_app')))" class="action-item"
                        (click)="openApplication(item)">
                        <img src="../../../../assets/img/icons/edit.svg" alt="Edit" title="Edit">
                      </div>
                      <div *ngIf="((!userAppFlag && isAdmin && !isFromGCC && userPermissions.includes('clone_apptemplate')) ||(userAppFlag && userPermissions.includes('clone_app')))" class="action-item"
                        (click)="clone(item)">
                        <img src="../../../../assets/img/icons/duplicate.svg" alt="Clone" title="Clone">
                      </div>
                      <div *ngIf="(isAdmin && !isFromGCC) && userAppFlag && userPermissions.includes('create_apptemplate')" class="action-item" (click)="saveAsTemplate(item)">
                        <img src="../../../../assets/img/icons/save-as-template.svg"
                          alt="Create Template From Solution" title="Create Template From Solution">
                      </div>
                      <div *ngIf="(!userAppFlag && isAdmin && userPermissions.includes('delete_apptemplate') ) || (userAppFlag && userPermissions.includes('delete_app'))" class="action-item"
                        (click)="confirmAndDelete(item)">
                        <img src="../../../../assets/img/icons/delete.svg" alt="Delete" title="Delete">
                      </div>
                      <div *ngIf="!isAdmin && !userAppFlag" class="action-item" (click)="saveAsApplication(item)">
                        <img src="../../../../assets/img/icons/save-as-application.svg"
                          alt="Create New Solution From Template" title="Create New Solution From Template">
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="filteredApplications.length===0" style="justify-content: center;">No Record Found</div>
          <div class="pagination-container" *ngIf="totalPages > 0">
            <span class="pagination-range">{{getPaginationRange()}}</span>
            <button class="pagination-btn" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">&lsaquo;</button>
            <span class="pagination-range">{{currentPage}}</span>
            <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">&rsaquo;</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
 
<ng-container *ngIf="isModalOpen">
  <app-modal *ngIf="modalType === 'delete'"  [modalType]="'delete'" [isAdmin]="isAdmin" [selectedApplication]="selectedApplication"
    (emitCloseEvent)="closeModal($event)" (emitDeleteAction)="delete($event)"></app-modal>
 
    <app-modal *ngIf="modalType === 'publish_unpublish'" [modalType]="'publish_unpublish'" [isAdmin]="isAdmin" [shareItem]="shareItem" (emitCloseEvent)="closeModal($event)"></app-modal>
</ng-container>
<!-- <ng-container *ngIf="isDialogOpen">
  <app-modal [modalType]="'dialog'" (emitCloseEvent)="closeDialog($event)" [selectedApplication]="selectedApplication"></app-modal>
</ng-container> -->